import { type TTagProps, Tag } from '~/components/tag'
import { type ScopedProps, useListItemContext } from '../../list-item'

type ListItemTagProps = Omit<TTagProps, 'variant'> & {
  variant: 'principal' | 'secondary'
  testID?: string
}

export const ListItemTag = (props: ListItemTagProps) => {
  const {
    children,
    variant = 'principal',
    __scopeListItem,
    testID,
  } = props as ScopedProps<ListItemTagProps>
  const { disabled } = useListItemContext('ListItemTag', __scopeListItem)
  return (
    <>
      {!disabled && children && (
        <Tag.Root variant={variant} testID={testID}>
          <Tag.Label>{children?.toString()}</Tag.Label>
        </Tag.Root>
      )}
    </>
  )
}
